






























































import { Component, Vue } from 'vue-property-decorator';
import { getAppInfo, getDetailApiInfo } from '@/apis/controll';
import { Status, ScanOperation } from '../../type/enums';
import appSecret from './components/app-secret.vue';
import mobileDetail from './components/mobile/mobile-detail.vue';
import webDetail from './components/web/web-detail.vue';
import backToPrevious from './components/back-to-pre.vue';
import MerchantDetail from './components/web/merchant-detail.vue';
import { handleErrorMessageToast } from '@/common/util';
import { checkAndCompleteMobileType } from './util';

@Component({
    name: 'detail',
    components: {
        appSecret,
        mobileDetail,
        webDetail,
        backToPrevious,
        MerchantDetail,
    },
})
export default class extends Vue {
    list: Record<string, any> = {};

    apiInfos: Record<string, any>[] = [];

    Status = Status;

    appOldName = '';
    appOldIcon = '';

    get category() {
        return this.$route.params.category;
    }
    get isMerchantApp() {
        return this.$route.query.business === '1';
    }

    get isShowApiInfo() {
        return (
            this.list.status !== Status.pending &&
            this.list.status !== Status.fail
        );
    }

    getStatus(status: number): string {
        switch (status) {
            case Status.pass:
                return '审核通过';
            case Status.pending:
                return '审核中';
            case Status.fail:
                return '已驳回';
            default:
                return '其他';
        }
    }

    get appId() {
        return this.$route.params.appId;
    }

    async getDetailApiInfo() {
        try {
            const res = await getDetailApiInfo(this.appId);
            if (res.data.result === 1) {
                this.apiInfos = res.data.scopes;
            } else {
                handleErrorMessageToast(
                    res.data.error_msg || '请求出错，请重试',
                );
            }
        } catch (e) {
            handleErrorMessageToast('服务器错误');
        }
    }

    async getAppInfo() {
        try {
            const res: any = await getAppInfo(this.appId);

            if (res.data.result === 1) {
                this.list = checkAndCompleteMobileType(res.data.appInfo);
                this.appOldName = res.data.appInfo.name;
                this.appOldIcon = res.data.appInfo.icon;
            } else {
                this.$message.error(
                    (res.data && res.data.error_msg) || '请求出错，请重试',
                );
            }
        } catch (e) {
            if (e !== 'custom error') {
                this.$message.error('服务器错误');
            }
        }
    }
    modifyApp() {
        this.$router.push({
            name: 'modifyApp',
            params: {
                appId: this.appId,
            },
            query: {
                business: '2',
            },
        });
    }

    checkData() {
        this.$router.push({
            name: 'dataCenter',
        });
    }
    created() {
        if (!this.isMerchantApp) {
            this.getAppInfo();
            if (this.list.status !== Status.pending) {
                this.getDetailApiInfo();
            }
        }
    }
}
